enum EVendorRouteName {
  SCORING = 'scoring',
}

export default EVendorRouteName;
